import brandDesign from "./brandDesign.json";
import comingSoon from "./comingSoon.json";
import creatorStudy from "./creatorStudy.json";
import home from "./home.json";
import howToGetSketch from "./howToGetSketch.json";
import landing from "./landing.json";
import sketchDrop from "./sketchDrop.json";
import sketchPay from "./sketchPay.json";
import sketchWallet from "./sketchWallet.json";
import systemIntegration from "./systemIntegration.json";
import usingPay from "./usingPay.json";
import usingWallet from "./usingWallet.json";
import whatIsSketch from "./whatIsSketch.json";
import whoIsCreator from "./whoIsCreator.json";

export const en = {
  home,
  howToGetSketch,
  sketchWallet,
  sketchPay,
  landing,
  comingSoon,
  whatIsSketch,
  usingWallet,
  usingPay,
  brandDesign,
  creatorStudy,
  whoIsCreator,
  systemIntegration,
  sketchDrop,
};
